/**
 * Session Header Component
 * Displays session title, date, duration, and location
 */

import { formatDuration, formatDate } from '../api/firebase';

interface SessionData {
  title: string;
  duration: number;
  location?: string;
  createdAt: string;
  viewCount: number;
}

/**
 * Render the session header
 */
export function renderSessionHeader(
  session: SessionData,
  container: HTMLElement
): void {
  const { title, duration, location, createdAt, viewCount } = session;

  container.innerHTML = `
    <header class="session-header">
      <h1 class="session-title">${escapeHtml(title)}</h1>
      <div class="session-meta">
        <span class="session-meta-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          ${formatDate(createdAt)}
        </span>
        <span class="session-meta-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          ${formatDuration(duration)}
        </span>
        ${location ? `
        <span class="session-meta-item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          ${escapeHtml(location)}
        </span>
        ` : ''}
      </div>
      <div class="view-count">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
        ${viewCount} ${viewCount === 1 ? 'view' : 'views'}
      </div>
    </header>
  `;
}

/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
